
const truncateString = (str, maxLength) => {
  if (!str) return '';
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + '...';
  }
  return str;
};

export default truncateString;